export const variableChartOptions = {
    chart: {
        type: 'variablepie',
        height: 230,
        width: 250,
        backgroundColor: 'transparent',
    },
    title: {
        text: undefined,
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        headerFormat: undefined,
        pointFormat:
            '{point.name}: <b>{point.percentage:.1f}%</b> ({point.y})',
    },
    series: [{
        minPointSize: 10,
        innerSize: '75%',
        zMin: 0,
        name: '',
        data: [],
        dataLabels: {
            enabled: false,
        },
    }],
};